// extracted by mini-css-extract-plugin
export default {"feedbackButton":"FeedbackButton_feedbackButton__vIagZ","icon":"FeedbackButton_icon__toxCC","label":"FeedbackButton_label__z1W3j"};